import { getAuthAxiosBackend } from "@/helpers/axios"

class SettingServices{

    getAll(data = {}) {
        return getAuthAxiosBackend().get('Setting', { params: data })
    }

    getAllLastUpdate(minutes, data = {}){
        return getAuthAxiosBackend().get('Setting/lastUpdate/' + minutes, { params: data })
    }

    getByKey(key, data = {}){
        return getAuthAxiosBackend().get('Setting/key/' + key, { params: data })
    }

    getByKeyLastUpdate(key, minutes, data = {}){
        return getAuthAxiosBackend().get('Setting/key/' + key + '/lastUpdate/' + minutes, { params: data })
    }

    getByCategory(category, data = {}){
        return getAuthAxiosBackend().get('Setting/category/' + category, { params: data })
    }

    getByCategoryLastUpdate(category, minutes, data = {}){
        return getAuthAxiosBackend().get('Setting/category/' + category + '/lastUpdate/' + minutes, { params: data })
    }
}

export default new SettingServices()